// extracted by mini-css-extract-plugin
export default {"title":"tcod29K2FM7nuqZh5vNhs","titleSuffix":"_3K6vOKke7WwTfUePjaq3Vr","subtitle":"_3g3GFpoQfSWnnkIW6jW_Km","progressList":"Gqbz9zZHuoItne_HZ2wnr"};